'use client';

import SmallArrow from '@/assets/svg/SmallArrow';
import { Direction } from '@/types/direction';
import { cn } from '@/lib/utils';
import Link from 'next/link';

interface SectionProps {
  data: { name: string; description: string; color: string }[];
}

export default function ServicesSection(props: SectionProps) {
  const { data } = props;

  return (
    <div className='py-20 sm:py-5 md:py-10'>
      <ul>
        {data.map((section, index: number) => (
          <div
            className={cn(
              'grid grid-cols-2 lg:grid-cols-2 sm:flex lg:gap-8 sm:flex-col md:flex md:flex-col md:gap-6 sm:gap-6 sm:px-2 lg:px-4 md:px-4 px-24 gap-12 py-6 min-h-52 2xl:pl-[160px] 2xl:pr-[160px]',
            )}
            key={section.color}
          >
            <div className='flex gap-4 lg:col-span-1'>
              <div
                className='2xl:w-6 2xl:h-6 w-4 h-4 sm:w-3 sm:h-3 mt-0.5 rounded-full shrink-0'
                style={{
                  backgroundColor: section.color,
                }}
              />
              <div className='2xl:text-[30px] text-[20px]  break-words sm:text-[16.88px] leading-[125%] tracking-normal uppercase font-bold -translate-y-1'>
                {section.name}
              </div>
            </div>
            <div className='col-span-1 sm:pl-7'>
              <p className='sm:text-[14px] 2xl:text-[18px] text-[14px] leading-[131%] font-normal font-poppins color-black'>
                <span dangerouslySetInnerHTML={{ __html: section.description }} />
              </p>
            </div>
          </div>
        ))}
      </ul>
    </div>
  );
}
